import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M16.99 8.001c2.164.01 3.35.083 4.233.673.436.292.811.667 1.103 1.103.405.607.566 1.356.63 2.466A2 2 0 0 0 22 12h-.564l-.012-.135c-.063-.62-.17-.949-.292-1.167l-.053-.087a2.5 2.5 0 0 0-.493-.544l-.197-.146c-.217-.145-.545-.273-1.254-.345C18.4 9.501 17.435 9.5 16 9.5h-3c-1.436 0-2.4.001-3.135.076-.62.063-.949.17-1.167.292l-.087.053a2.5 2.5 0 0 0-.544.493l-.146.197c-.145.217-.273.545-.345 1.254-.075.735-.076 1.7-.076 3.135 0 1.436.001 2.4.076 3.135.072.709.2 1.037.345 1.254l.146.197q.236.286.544.493l.087.053c.218.122.546.229 1.167.292.735.075 1.7.076 3.135.076h3c1.436 0 2.4-.001 3.135-.076.709-.072 1.037-.2 1.254-.345l.197-.146c.19-.156.356-.34.493-.544l.053-.087c.122-.218.229-.546.292-1.167l.012-.135H22c.346 0 .672-.09.956-.244-.064 1.111-.225 1.86-.63 2.467l-.113.16a4 4 0 0 1-.99.943l-.195.118c-.863.482-2.029.547-4.039.555L16 22h-3l-.99-.001c-2.01-.008-3.175-.073-4.038-.555l-.195-.118a4 4 0 0 1-.99-.943l-.113-.16C6 19.213 6 17.809 6 15c0-2.633 0-4.032.556-5.028l.118-.195a4 4 0 0 1 .943-.99l.16-.113c.883-.59 2.07-.664 4.234-.673L13 8h3z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#fff",
      "stroke-width": "1.5",
      d: "M20 12.75h2c.69 0 1.25.56 1.25 1.25v2c0 .69-.56 1.25-1.25 1.25h-2a2.25 2.25 0 0 1 0-4.5Z"
    }, null, -1)
  ])))
}
export default { render: render }